var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedoUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6L15.4243 6.42426L15.8485 6L15.4243 5.57574L15 6ZM11.25 14.85C11.5814 14.85 11.85 14.5814 11.85 14.25C11.85 13.9186 11.5814 13.65 11.25 13.65L11.25 14.25L11.25 14.85ZM11.25 9.75L11.6743 10.1743L15.4243 6.42426L15 6L14.5757 5.57574L10.8257 9.32574L11.25 9.75ZM15 6L15.4243 5.57574L11.6743 1.82574L11.25 2.25L10.8257 2.67426L14.5757 6.42426L15 6ZM15 6L15 5.4L7.125 5.4L7.125 6L7.125 6.6L15 6.6L15 6ZM7.125 14.25L7.125 14.85L11.25 14.85L11.25 14.25L11.25 13.65L7.125 13.65L7.125 14.25ZM3 10.125L2.4 10.125C2.4 12.7345 4.51546 14.85 7.125 14.85L7.125 14.25L7.125 13.65C5.1782 13.65 3.6 12.0718 3.6 10.125L3 10.125ZM7.125 6L7.125 5.4C4.51546 5.4 2.4 7.51545 2.4 10.125L3 10.125L3.6 10.125C3.6 8.1782 5.1782 6.6 7.125 6.6L7.125 6Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedoUnselected);
export default __webpack_public_path__ + "static/media/redo_unselected.7284474557cf09c232e8d7bee5c2fc8e.svg";
export { ForwardRef as ReactComponent };